<template>
  <div
    class="px-3"
    :class="columnClasses"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    col: {
      type: String,
      default: ''
    },
    colSm: {
      type: String,
      default: ''
    },
    colMd: {
      type: String,
      default: ''
    },
    colLg: {
      type: String,
      default: ''
    }
  },

  computed: {
    columnClasses () {
      let classes = []

      if (this.colSm) {
        classes.push('sm:w-' + this.colSm)
      }

      if (this.colMd) {
        classes.push('md:w-' + this.colMd)
      }

      if (this.colLg) {
        classes.push('lg:w-' + this.colLg)
      }

      if (this.col) {
        classes.push('w-' + this.col)
      }

      return classes.length === 0 ? 'flex-1' : classes
    }
  }
}
</script>
